// This class knows:
//   - ALL about c9-tracking
//   - Nothing about claim-form-app
import track from 'c9-tracking';

import { consumers, errorTypes, item as TrackingItem } from 'c9-tracking';
import { v4 as getUuid } from 'uuid';
import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

const instanceId = getUuid();
const currentConsumers = { consumers: [consumers.ga, consumers.kibana] };

// @TODO
//   - How to get formConfig from state in a non-React-function?
const trackInfo = (formConfig: FormConfig, payload: TrackingItem[], pageId: string): void => {
    payload = addFormDataToPayload(formConfig, payload, pageId);

    track.info(payload, instanceId, currentConsumers);

    trackLocally('Info', payload);
};

const trackConversion = (formConfig: FormConfig, payload: TrackingItem[], pageId: string): void => {
    payload = addFormDataToPayload(formConfig, payload, pageId);

    track.convert(payload, instanceId, currentConsumers);

    trackLocally('Conversion', payload);
};

const trackInteract = (formConfig: FormConfig, payload: TrackingItem[], pageId: string): void => {
    payload = addFormDataToPayload(formConfig, payload, pageId);

    track.interact(payload, instanceId, currentConsumers);

    trackLocally('Interact', payload);
};

// @TODO
//   - What to do with this url thingie?
//     new URL(url, window.location.href).href
//
// @TODO
//   - How can we provide meta data like formId etc to track.navigate?
export const trackNavigate = (formConfig: FormConfig, url: string, urlName: string): void => {
    track.navigate(url, urlName, instanceId, currentConsumers);

    trackLocally('Navigation', { url, urlName });
};

// Shorthand helper
// Shields the user from knowing - or understanding - the c9-tracking inner workings
export const trackInfoEvent = (formConfig: FormConfig, event: string, pageId: string): void => {
    const payload: TrackingItem[] = [{ key: 'event', value: event }];

    trackInfo(formConfig, payload, pageId);
};

// Used for composite values with one event and an associated value
// Eg. form-duration-seconds and an associated durationInSeconds
export const trackInfoEventValue = (
    formConfig: FormConfig,
    event: string,
    value: TrackingItem['value'],
    pageId: string
): void => {
    const payload = getTrackingEventValue(event, value);

    trackInfo(formConfig, payload, pageId);
};

export const trackInteractEvent = (formConfig: FormConfig, event: string, pageId: string): void => {
    const payload: TrackingItem[] = [{ key: 'event', value: event }];

    trackInteract(formConfig, payload, pageId);
};

const getTrackingEventValue = (event: string, value: TrackingItem['value']) => {
    const payload: TrackingItem[] = [
        { key: 'event', value: event },
        { key: 'value', value }
    ];

    return payload;
};

export const trackInteractEventValue = (
    formConfig: FormConfig,
    event: string,
    value: TrackingItem['value'],
    pageId: string
): void => {
    const payload = getTrackingEventValue(event, value);

    trackInteract(formConfig, payload, pageId);
};

// @TODO
//   - Take key-value?
//     But with which contents?
export const trackConversionItem = (formConfig: FormConfig): void => {
    trackConversion(formConfig, [], '');
};

// @TODO
//   - How to track submission errors?
//     How to distinguish them from other techincal errors?
//
// Seems like it is not possible to push
// meta data to track.fault :-/
export const trackFault = (formConfig: FormConfig | undefined, error: any, pageId: string): void => {
    if (formConfig) {
        const formId = formConfig.formId;
        const formName = formConfig.caption;

        const payload = addFormDataToPayload(formConfig, [], pageId);

        payload.push({
            key: 'error',
            value: error
        });

        track.fault(
            `A technical error occurred: ${formId} - ${formName}`,
            errorTypes.tech,
            instanceId,
            JSON.stringify(payload),
            currentConsumers
        );
    } else {
        track.fault(
            `A technical error occurred: unknown - unknown`,
            errorTypes.tech,
            instanceId,
            undefined,
            currentConsumers
        );
    }
};

// The tracking framework does not return any output
// locally and does not call any environment
// To be able to debug locally, this method is needed
const trackLocally = (trackingType: string, message: any): void => {
    if (!process.env.REACT_APP_TRACK_TO_CONSOLE || process.env.REACT_APP_TRACK_TO_CONSOLE === '0') {
        return;
    }

    console.debug('Tracked: ' + trackingType);
    console.debug(JSON.stringify(message, null, 4));
};

// This data is always added to all tracking
// It enables more pinpointed tracking, like which
// page the user dropped out of
const addFormDataToPayload = (formConfig: FormConfig, payload: TrackingItem[], pageId: string): TrackingItem[] => {
    payload.push({
        key: 'form-id',
        value: formConfig.formId
    });

    payload.push({
        key: 'form-title',
        value: formConfig.caption
    });

    if (pageId !== '') {
        payload.push({
            key: 'page-id',
            value: pageId
        });
    }

    return payload;
};
